import React from "react";
import {
    User,
    Phone,
    MessageCircle,
    Calendar,
    Clock,
    Shield
} from "lucide-react";

export default function CustomerDetails({

    conversation

}) {

    if (!conversation) {

        return (

            <div className="customer-details">

                <div className="customer-empty">

                    <User size={70} />

                    <h3>

                        Customer Details

                    </h3>

                    <p>

                        Select a conversation

                    </p>

                </div>

            </div>

        );

    }

    return (

        <div className="customer-details">

            {/* Avatar */}

            <div className="customer-header">

                <div className="customer-avatar">

                    {

                        conversation.name
                            ?

                            conversation.name
                                .charAt(0)
                                .toUpperCase()

                            :

                            <User size={40} />

                    }

                </div>

                <h2>

                    {

                        conversation.name ||

                        "Unknown User"

                    }

                </h2>

                <p>

                    {

                        conversation.phoneNumber

                    }

                </p>

            </div>

            {/* Details */}

            <div className="customer-section">

                <div className="detail-row">

                    <User size={18} />

                    <div>

                        <label>

                            Name

                        </label>

                        <span>

                            {

                                conversation.name ||

                                "-"

                            }

                        </span>

                    </div>

                </div>

                <div className="detail-row">

                    <Phone size={18} />

                    <div>

                        <label>

                            Phone

                        </label>

                        <span>

                            {

                                conversation.phoneNumber

                            }

                        </span>

                    </div>

                </div>

                <div className="detail-row">

                    <MessageCircle size={18} />

                    <div>

                        <label>

                            Last Message

                        </label>

                        <span>

                            {

                                conversation.lastMessage ||

                                "-"

                            }

                        </span>

                    </div>

                </div>

                <div className="detail-row">

                    <Calendar size={18} />

                    <div>

                        <label>

                            Last Active

                        </label>

                        <span>

                            {

                                conversation.lastMessageTime

                                    ?

                                    new Date(

                                        conversation.lastMessageTime

                                    ).toLocaleDateString()

                                    :

                                    "-"

                            }

                        </span>

                    </div>

                </div>

                <div className="detail-row">

                    <Clock size={18} />

                    <div>

                        <label>

                            Time

                        </label>

                        <span>

                            {

                                conversation.lastMessageTime

                                    ?

                                    new Date(

                                        conversation.lastMessageTime

                                    ).toLocaleTimeString(

                                        [],

                                        {

                                            hour: "2-digit",

                                            minute: "2-digit"

                                        }

                                    )

                                    :

                                    "-"

                            }

                        </span>

                    </div>

                </div>

                <div className="detail-row">

                    <Shield size={18} />

                    <div>

                        <label>

                            Status

                        </label>

                        <span>

                            Active

                        </span>

                    </div>

                </div>

            </div>

        </div>

    );

}
